
/**
* Returns custom demographic name and value as a string for dispaly
*
* @param {array of objects} demos - from $store value global/demographicsSearchable
* @param {array of 2 strings} filter - key[0] and value[1] containting filter name and selected value by user
* @returns {string} the readable value of the demo name and chosen value
* @return {boolean} false if no demographics or not a demographic
*/
export function getDemoName(demos, filter, descriptiveChip = true) {
    if(!filter[0] || !filter[0].includes('_') || !demos.length) return false
    
    // Escape if demographic filter value is not a string
    if (!filter[1] || typeof filter[1] !== 'string') {
        return false
    }
    
    let demoId = filter[0].split('_')[1]
    let currentDemo = demos.find(demo => demo.id === parseInt(demoId))
    if(!currentDemo) return false
    let filterType = currentDemo['value_type']
    let filterChoices

    switch(filterType) {
        case 'boolean':
            filterChoices = filter[1].includes('1') ? 'Yes' : 'No'
            break
        case 'option':
            let splitOptions = filter[1].split(',')
            filterChoices = splitOptions.map(fOpt => currentDemo.options.find(opt => opt.id === parseInt(fOpt)).value).join(', ')
            break
        case 'number':
        case 'string':
        case 'date':
            let splitChoices = filter[1].split(':')
            if (splitChoices.length > 2) {
                filterChoices = `between ${splitChoices[1]} and ${splitChoices[2]}`
            } else {
                // Use descriptive names for operators
                const operatorMap = {
                    'eq': 'Equal To',
                    'gt': 'Greater Than',
                    'lt': 'Less Than', 
                    'gte': 'Greater Than or Equal To',
                    'lte': 'Less Than or Equal To',
                    'has': 'Contains',
                    'start': 'Starts With',
                    'end': 'Ends With'
                }
                const operator = operatorMap[splitChoices[0]] || splitChoices[0]
                filterChoices = `${operator} ${splitChoices[1]}`
            }
            break
    }

    const demoName = currentDemo.name;
    const fullDisplay = `${demoName}: ${filterChoices}`;
    
    // Only add contextual prefix to Yes/No filters and operators
    if (!descriptiveChip) {
        const isBoolean = filterChoices === 'Yes' || filterChoices === 'No';
        const hasOperator = /^(Equal To|Greater Than|Less Than|Contains|Starts With|Ends With)/.test(filterChoices);
        const needsPrefixOnChip = isBoolean || hasOperator;
        
        return needsPrefixOnChip ? fullDisplay : filterChoices;
    }
    
    // Default behavior - return full display (descriptive)
    return fullDisplay;
}
